import type { ComponentType } from 'react';

import type { FeatureFlagKey } from '../feature-flag.constants';
import { FeatureRoute } from './feature-route';

/**
 * {@link FeatureRoute} as a route `Component`, for the plain `.ts` route
 * files that hold no JSX. Kept apart from `FeatureRoute` so that file only
 * exports components, which fast refresh needs.
 *
 * @example
 * { path: '/today', Component: withFeature(FeatureFlagKey.MODULE_TODAY, TodayPage) }
 */
const withFeature = (
  flag: FeatureFlagKey,
  Page: ComponentType,
  redirectTo?: string
) => {
  const Guarded = () => (
    <FeatureRoute flag={flag} redirectTo={redirectTo}>
      <Page />
    </FeatureRoute>
  );
  return Guarded;
};

export { withFeature };
